module.exports = __webpack_public_path__ + "svg/moderator_icon.svg?60b9305fcda45fae0bd8e939139c574d";